export const GP_SPECIALTY_ID = 37
export const GP_FAMILY_SPECIALTY_ID = 35
export const PSYCHOLOGY_SPECIALTY_ID = 64
export const CLINIC_PSYCHOLOGY_SPECIALTY_ID = 55
export const VETERINARIAN = 90
export const PEDIATRICS = 52
export const LACTATION_CONSULTANT = 80
export const INFANT_SLEEP_COUNSELING = 81
export const NUTRITION_DIET = 16
export const ENDOCRINOLOGY = 18
export const DERMATOLOGY = 15
export const SCIENCE_PHYSICAL_ACTIVITY_SPORT = 85
export const WORK_MEDICINE = 21
export const INTERNAL_MEDICINE = 33


// WEBPACK FOOTER //
// ./src/constants/db/specialties.js